import { mutationTree } from 'typed-vuex';
import { type FeatureFlagRequirement, type FeatureFlags, testFeatureFlagRequirements } from '@redviking/argonaut-util/src/feature-flags';

const routerState = {
    k8sChartNamespace: '',
    featureFlags: {} as Partial<FeatureFlags>,
};

const mutations = mutationTree(routerState, {
    setChartNamespace (state, namespace: string) {
        state.k8sChartNamespace = namespace;
    },
    setFeatureFlags (state, flags: FeatureFlags) {
        state.featureFlags = flags;
    },
});

export default {
    state: routerState,
    mutations,
    getters: {
        testFeatureFlagRequirements: (state: typeof routerState) => (requirements: FeatureFlagRequirement[]) => {
            return testFeatureFlagRequirements(requirements, state.featureFlags);
        },
    },
};
